import { DateTime } from 'luxon';
import {
    isUnlimitedFromDate,
    Parser,
    unlimitedFromDate,
    unlimitedToDate,
} from 'dg-web-shared/lib/Date.ts';
import { Store, useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { getOrElse, isDefined } from 'dg-web-shared/lib/MaybeV2.ts';
import * as ClearanceEditState from '../state/ClearanceEditState.ts';
import { FromDatePickerSlideIn } from './Shared.tsx';

export function ClearanceEditValidityFromDateSlideIn() {
    const { storeState, update } = useStore(store => ({
        edit: ClearanceEditState.Edit.get(store),
        server: ClearanceEditState.Server.get(store),
        layout: ClearanceEditState.Layout.get(store),
    }));
    const { language } = useLanguage();

    const server = storeState.server.data;
    const validFrom = getOrElse(
        storeState.edit.validFrom,
        isDefined(server)
            ? Parser.isoToDateTime(server.validFrom)
            : unlimitedFromDate,
    );
    const validTo = getOrElse(
        storeState.edit.validTo,
        isDefined(server)
            ? Parser.isoToDateTime(server.validTo)
            : unlimitedToDate,
    );
    return (
        <FromDatePickerSlideIn
            open={!!storeState.layout.fromDatePickerOpen}
            onClose={() =>
                update(store =>
                    ClearanceEditState.Layout.stateWrite(store, {
                        fromDatePickerOpen: false,
                    }),
                )
            }
            validFrom={isUnlimitedFromDate(validFrom) ? null : validFrom}
            validTo={validTo}
            onSelect={(selectedDate: DateTime) =>
                update((s: Store): string => {
                    ClearanceEditState.Edit.stateWrite(s, {
                        validFrom: selectedDate,
                    });
                    ClearanceEditState.Layout.stateWrite(s, {
                        fromDatePickerOpen: false,
                    });
                    return 'ClearanceEditValidityFromDateSlideIn-setDate';
                })
            }
            language={language}
        />
    );
}
